module.exports = __webpack_public_path__ + "img/2-3-1.83d7d5b7.png";